import Exacta from './SingleLeg/Exacta';
import Trifecta from './SingleLeg/Trifecta';
import Superfecta from './SingleLeg/Superfecta';
import Pentafecta from './SingleLeg/Pentafecta';
import PickTwo from './MultiLeg/PickTwo';
import PickThree from './MultiLeg/PickThree';
import PickFour from './MultiLeg/PickFour';
import PickFive from './MultiLeg/PickFive';
import PickSix from './MultiLeg/PickSix';

export default {
	'exacta': Exacta,
	'trifecta': Trifecta,
	'superfecta': Superfecta,
	'pentafecta': Pentafecta,
	'pick-2': PickTwo,
	'pick-3': PickThree,
	'pick-4': PickFour,
	'pick-5': PickFive,
	'pick-6': PickSix
};



/** WEBPACK FOOTER **
 ** ./site/sites/all/themes/custom/abr_theme/js/gambling-calculator/bets/bets.js
 **/